import { WithOwner, ownerData } from "../IDBSchema";
import { IssuanceBasePatchPayload, IssuanceBase } from "../../../schema/generated/Issuance";
import { EntityDataApi } from "../IndexedDBApi";
import { getFromIdPayload } from "../../../schema/general";
import { issuanceRow } from "../../../schema/console/issuance";
import { IssuanceForMaterialSearch } from "../../../schema/console/material";
import { idbEntityDefs } from "../generated/entityDefs";
import { StatusResponse } from "../../../schema/console/statusData";
import { required } from "../../../util/typed";

export class IssuanceDataApi extends EntityDataApi<IssuanceBase> {
  public readonly def = idbEntityDefs.Issuance;

  // 現行挙動を維持するため、Issuanceは論理削除を考慮せず返す
  public async getAll(ownerId: string): Promise<IssuanceBase[]> {
    return await this.listByOwner(ownerId, false);
  }

  public async getById(payload: WithOwner<getFromIdPayload>): Promise<IssuanceBase | null> {
    return await this.findById(payload, false);
  }

  public async getForMaterialSearch(payload: WithOwner<getFromIdPayload>): Promise<IssuanceForMaterialSearch | null> {
    const issuance = await this.getById(payload);
    if (!issuance) {
      return null;
    }
    const user = await this.IDB().userDataApi.getFullDataById({ id: issuance.preparer_user_id, ownerId: payload.ownerId });
    return { ...issuance, User: user };
  }

  public async getRowById(payload: WithOwner<getFromIdPayload>): Promise<issuanceRow | null> {
    const issuance = await this.getById(payload);
    if (!issuance) {
      return null;
    }
    const materials = await this.IDB().materialDataApi.getByIssuanceId(issuance.id, payload.ownerId);
    const user = await this.IDB().userDataApi.getFullDataById({ id: issuance.preparer_user_id, ownerId: payload.ownerId });
    return { ...issuance, Materials: materials, User: user };
  }

  public async getRowsById(payload: ownerData): Promise<issuanceRow[]> {
    const issuances = (await this.getAll(payload.ownerId)).filter((issuance) => issuance.preparer_user_id === payload.ownerId);
    const materials = await this.IDB().materialDataApi.getAll(payload.ownerId);
    const userIds = [...new Set(issuances.map((i) => i.preparer_user_id))];
    const users = await Promise.all(
      userIds.map((id) =>
        this.IDB().userDataApi.getFullDataById({
          id,
          ownerId: payload.ownerId,
        })
      )
    );
    const userMap = new Map(users.map((u) => [u.id, u]));
    return issuances.map((issuance) => ({
      ...issuance,
      Materials: materials.filter((m) => m.issuance_id === issuance.id),
      User: required(userMap.get(issuance.preparer_user_id), "登録者ユーザー"),
    }));
  }

  // オフラインでの備考編集。新規発行(put)はオンライン限定のため公開しない。
  public async patch(data: WithOwner<IssuanceBasePatchPayload>): Promise<StatusResponse> {
    return await this.patchRow(data);
  }
}
